var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',[_c('div',{staticClass:"common-page new-card"},[_c('div',{staticClass:"container-fluid"},[_c('h1',{staticClass:"common-page__main-title"},[_vm._v(_vm._s(_vm.$t('newCard')))]),_vm._v(" "),_c('dx-card-form',{ref:"form",attrs:{"disabled":_vm.sending},on:{"submit":_vm.onSubmit}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0406dd80","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NewCard.vue
// module id = null
// module chunks = 